import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";

// Decorative dusty rose ribbon SVG accent
const Ribbon = () => (
  <svg width="44" height="6" viewBox="0 0 44 6" className="text-dustyrose" aria-hidden>
    <path d="M0 3 H30 L34 0 L38 3 L34 6 L30 3" stroke="currentColor" strokeWidth="1" fill="none" />
  </svg>
);

export default function Craft() {
  const { t } = useLanguage();
  return (
    <section id="craft" data-testid="craft-section" className="relative bg-paper py-28 md:py-40">
      {/* dusty rose top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-dustyrose" aria-hidden />

      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-dustyrose-deep" />
              <span className="eyebrow !text-warmbrown">{t.craft.eyebrow}</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-ink">
              {t.craft.title}
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="font-body italic text-ink-soft max-w-md">{t.craft.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14 md:gap-y-20">
          {t.craft.items.map((it, i) => (
            <motion.div
              key={it.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.9, delay: i * 0.07 }}
              className="group"
              data-testid={`craft-item-${it.n}`}
            >
              <div className="flex items-center gap-4 mb-5">
                <span className="font-serif italic text-warmbrown text-xl">{it.n}</span>
                <span className="block flex-1 h-px bg-cream-300 group-hover:bg-dustyrose transition-colors duration-700" />
                <Ribbon />
              </div>
              <h3 className="font-serif text-2xl text-ink leading-snug">{it.k}</h3>
              <p className="font-body text-sm md:text-base text-ink-soft mt-4 leading-relaxed max-w-sm">{it.v}</p>
            </motion.div>
          ))}
        </div>

        {/* Editorial divider with image strip */}
        <div className="mt-24 md:mt-32 grid grid-cols-3 gap-2 md:gap-3 max-w-3xl mx-auto">
          {["/catalog/img8.jpg", "/catalog/img13.jpg", "/catalog/img11.jpg"].map((src, i) => (
            <div key={i} className="relative aspect-[4/5] overflow-hidden">
              <img src={src} alt="" aria-hidden className="w-full h-full object-cover transition-transform duration-[1600ms] hover:scale-[1.04]" />
              <div className="absolute inset-0 bg-dustyrose/0 hover:bg-dustyrose/10 transition-colors duration-700" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
